import { API_URLS } from "../config/api";

/**
 * Fetch weather data from NASA POWER API
 */
export async function fetchWeatherData(lat, lon, startDate, endDate) {
  const essentialParameters = [
    "PRECTOTCORR",
    "T2M",
    "T2M_MAX",
    "T2M_MIN",
    "RH2M",
    "WS2M",
    "ALLSKY_SFC_SW_DWN",
    "EVPTRNS",
  ];

  try {
    const params = new URLSearchParams({
      parameters: essentialParameters.join(","),
      community: "AG",
      longitude: lon,
      latitude: lat,
      start: startDate,
      end: endDate,
      format: "JSON",
    });

    const response = await fetch(
      `${API_URLS.NASA_POWER}?${params.toString()}`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    );

    if (!response.ok)
      throw new Error(`Weather API Error: ${response.statusText}`);
    return await response.json();
  } catch (error) {
    console.error("Error fetching weather data:", error);
    return { error: error.message };
  }
}
